import React, { Component } from 'react'
import propTypes from 'prop-types'
import Actionable from 'components/actionable'
import { prefix } from 'helpers/component'

const getClassName = prefix('pivotTable-list-')

class List extends Component {
  render () {
    let {onSelect} = this.props
    const { data, entityClass, entityActions } = this.props
    if (onSelect == null) onSelect = () => { }

    let createEntity
    if (typeof (entityClass) === 'function') {
      createEntity = React.createFactory(entityClass)
    } else {
      createEntity = (props) => React.cloneElement(entityClass, props)
    }

    let entities
    if (entityActions) {
      entities = data.map(entity => {
        entity['hasExtraDetails'] = true
        const newEntity = createEntity({ entity, onClick: () => onSelect(entity) })
        return (<Actionable key={'actionableEntity_' + entity.id} actions={entityActions}>{newEntity}</Actionable>)
      })
    } else {
      entities = data.map(entity => {
        entity['hasExtraDetails'] = true
        return createEntity({ key: entity.id, entity, onClick: () => onSelect(entity) })
      })
    }

    return (
      <div className={getClassName('container')}>
        {entities}
      </div>
    )
  }
}

List.propTypes = {
  theme: propTypes.object.isRequired,
  data: propTypes.arrayOf(propTypes.object).isRequired,
  entityClass: propTypes.oneOfType([
    propTypes.func,     // a React class to instanciate
    propTypes.element,  // a React element to clone
  ]),
  entityActions: Actionable.propTypes.actions,
  onSelect: propTypes.func,
}

export default List
